import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const certificationProficienciesReducer = createAsyncReducer({
    name: 'certificationProficiencies',
    initialState: {
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        loadByCertAndProf: create.asyncThunk(async ({ certId, profId }) => {
            return await Fetch.get(Routes.ajax_certification_proficiency_path({ certification_id: certId, proficiency_id: profId }));
        }, {
            pending: (state, action) => {
                state.loading = true;
                state.errorMessage = '';
            },
            fulfilled: (state, action) => {
                state.loading = false;
                state.records = { ...state.records, ...action.payload };
            },
            rejected: (state, action) => {
                const { message } = action.error;
                state.errorMessage = message;
                state.loading = false;
            }
        }),
        loadByCertificationId: create.asyncThunk(
            async (certId) => {
                return await Fetch.get(Routes.ajax_certification_proficiencies_path(certId));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.loading = false;
                }
            }
        )
    })
});

export default certificationProficienciesReducer;